import { render } from "./StatViewManager.vue?vue&type=template&id=53156d7b&scoped=true"
import script from "./StatViewManager.vue?vue&type=script&lang=js"
export * from "./StatViewManager.vue?vue&type=script&lang=js"

import "./StatViewManager.vue?vue&type=style&index=0&id=53156d7b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53156d7b"]])

export default __exports__